export default __webpack_public_path__ + "static/media/polygon-chain-logo.d101f762.png";